import { Row, Col, Container } from "react-bootstrap";
import OwnerShopProfile from "../../components/OwnerShopProfile/OwnerShopProfile";
import ShopItemsOwner from "../../components/ShopItemsOwner/ShopItems";
import { useParams } from "react-router-dom";
import BackArrow from "../../components/backArrow";
import Managebuttons from "../../components/Manage_Buttons";
import useManufacturerOwnerProfileState from "../../hooks/useManufacturerOwnerProfileState";

const ManufacturerOwnerProfile = () => {
  const { id } = useParams();
  const {
    shopData,
    suggest,
    setSuggest,
    suggestdetail,
    setSuggestdetail,
    suggestdata,
    suggestdatta,
  } = useManufacturerOwnerProfileState(id);

  return (
    <Container>
      <Col md={11} lg={11} className="mx-auto ">
        <Row>
          <Col md={4} lg={3} className="p-0">
            <OwnerShopProfile
              navigateTo="/manufacturer-update"
              Name="Update Manufacturer Profile"
              update="/manufacturer-update"
              post="/manufacturer-postAdd"
              shopData={shopData}
              setSuggest={setSuggest}
              suggestdatta={suggestdatta}
            />
          </Col>
          <Col md={8} lg={9} className=" screenHeight custom_ps-4">
            <div className="Form-Shadow h-100">
              <Row>
                <Col lg="6">
                  <BackArrow
                    back={`/manufacturer-bussines-Profile/${id}`}
                    mystyle="ps-3 pt-2 d-none d-lg-block"
                  />
                </Col>
                <Col lg="6" className="mt-2 pe-4">
                  <Managebuttons id={id} businessurl="/ManufacturerShop" />
                </Col>
              </Row>
              <ShopItemsOwner
                suggest={suggest}
                setSuggest={setSuggest}
                shopData={shopData}
                suggestdetail={suggestdetail}
                setSuggestdetail={setSuggestdetail}
                urlPass="/manufacturer-owner-view"
                navigateto="/manufacturer-form"
                shopid={id}
                post={`/manufacturer-postAdd/${id}`}
                suggestdata={suggestdata}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </Container>
  );
};

export default ManufacturerOwnerProfile;
